export { default as MainPage } from "./MainPage";
export { default as Appearance } from "./largeScreen/appearance/Appearance";
// export { default as UpgradeAnalytics } from "./largeScreen/analytics/UpgradeAnalytics";
// export { default as ProAnalytics } from "./largeScreen/analytics/ProAnalytics";
export { default as Analytics } from "./largeScreen/analytics/Analytics";

export { default as IndexMainPage } from './largeScreen/mainPage/Index'
